module.exports = __webpack_public_path__ + "img/logo-192.ea4844c4.png";